import { api } from 'api'
import { AxiosResponse } from 'axios'
import { ascend, path, prop, sort } from 'ramda'
import { ShiftWithCallouts } from 'pages/ReviewPage/AssignmentCallouts/types'

type GetShiftsWithCalloutsResponseDTO = {
  data: {
    company: {
      shifts: ShiftWithCallouts[]
    }
  }
}

export const getAssignmentsWithRequestedCallouts = async (): Promise<
  ShiftWithCallouts[]
> => {
  const data = await api.post<
    GetShiftsWithCalloutsResponseDTO,
    AxiosResponse<GetShiftsWithCalloutsResponseDTO>
  >('/company/graphql_dispatch/shifts_with_callouts_9998eb4d', {})

  const shifts = path(['data', 'data', 'company', 'shifts'], data)

  // 2D array of shifts with the worker's callouts
  const groupedShiftsByWorkers = shifts.map((shift) => {
    return shift.work.map((work) => ({
      ...shift,
      work: [work],
    }))
  })

  const flattenedShifts = groupedShiftsByWorkers.flat()

  const sortedShifts = sort(ascend(prop('startsAt')), flattenedShifts)

  return sortedShifts
}
